document.addEventListener('DOMContentLoaded', function() {
  var path = window.location.pathname;
  document.querySelectorAll('.collection-tab').forEach(function(tab) {
    if (tab.getAttribute('href') === path) {
      tab.classList.add('active');
    }
  });
});

// Mobile menu collection tabs
var menuProductNames = {
  'scorolash': { reviews: '1524' },
  'scorobrow': { reviews: '1158' },
  'lashbrowbundle': { reviews: '931' },
  'ultimatetrio': { reviews: '884' },
  'lashlushbundle': { reviews: '649' },
  'scorolush': { reviews: '827' },
  'scorogro': { reviews: '584' },
  'curler': { reviews: '31' },
  'lashwand': { reviews: '47' },
  'scorolash-scalp-massager': { reviews: '36' }
};

function renderMenuProducts(products, productList) {
  productList.innerHTML = products.slice(0, 4).map(function(p) {
    var info = menuProductNames[p.handle] || {};
    var imgSrc = '';
    if (p.images && p.images.length > 0) {
      imgSrc = p.images[0].src.split('?')[0] + '?width=80';
    }
    var img = imgSrc ? '<img src="' + imgSrc + '" width="40" height="40">' : '';
    return '<li><a href="/products/' + p.handle + '" class="mobile-menu-product">' +
      '<div class="mobile-menu-product__img">' + img + '</div>' +
      '<div class="mobile-menu-product__text">' +
      '<span class="mobile-menu-product__reviews"><span class="mobile-menu-product__stars">★★★★★</span> ' + (info.reviews || '') + ' Reviews</span>' +
'<span class="mobile-menu-product__name">' + p.title + '</span>' +
      '</div>' +
      '<span class="mobile-menu-product__arrow">›</span>' +
      '</a></li>';
  }).join('');
  productList.classList.remove('loading');
}

function loadMenuCollection(collection, productList) {
  var url = collection === 'all' ?
    '/collections/all/products.json?limit=4&fields=handle,title,images' :
    '/collections/' + collection + '/products.json?limit=4&fields=handle,title,images';

  productList.classList.add('loading');

  fetch(url)
    .then(function(r) { return r.json(); })
    .then(function(data) { renderMenuProducts(data.products, productList); })
    .catch(function() {
      productList.innerHTML = '<li style="padding:14px 0;text-align:center;color:#999;font-size:13px;">Could not load products.</li>';
      productList.classList.remove('loading');
    });
}

document.addEventListener('click', function(e) {
  var tab = e.target.closest('.mobile-menu-tab[data-collection]');
  if (!tab) return;

  var tabs = document.querySelectorAll('.mobile-menu-tab[data-collection]');
  var productList = document.getElementById('mobile-menu-product-list');
  if (!productList) return;

  tabs.forEach(function(t) { t.classList.remove('active'); });
  tab.classList.add('active');

  loadMenuCollection(tab.getAttribute('data-collection'), productList);
});

document.addEventListener('click', function(e) {
  var menuToggle = e.target.closest('[aria-controls="MenuDrawer"]');
  if (!menuToggle) return;

  setTimeout(function() {
    var productList = document.getElementById('mobile-menu-product-list');
    if (!productList || productList.children.length > 0) return;
    loadMenuCollection('lashes', productList);
  }, 100);
});
// Collection page AJAX tabs
document.addEventListener('click', function(e) {
  var tab = e.target.closest('.collection-tab');
  if (!tab) return;

  e.preventDefault();

  var tabs = document.querySelectorAll('.collection-tab');
  var grid = document.getElementById('ProductsList');
  var productGrid = document.getElementById('ProductGridContainer');
  if (!grid || !productGrid) return;

  tabs.forEach(function(t) { t.classList.remove('active'); });
  tab.classList.add('active');

  var href = tab.getAttribute('href');
  window.history.pushState({}, '', href);

  grid.style.opacity = '0.4';
  grid.style.transition = 'opacity 0.2s ease';

  fetch(href + '?sections=main-collection-product-grid&columns_mobile=1')
    .then(function(r) { return r.json(); })
    .then(function(data) {
      var sectionKey = Object.keys(data)[0];
      var html = data[sectionKey];
      var parser = new DOMParser();
      var doc = parser.parseFromString(html, 'text/html');
      var newGrid = doc.getElementById('ProductGridContainer');
      if (newGrid) {
        productGrid.innerHTML = newGrid.innerHTML;
      }
      grid.style.opacity = '1';
    })
    .catch(function() {
      window.location.href = href;
    });
});